export const SET_CALENDAR_EVENTS_DATA = 'reports/set-calendar-events-data';
export const SET_CALENDAR_EVENTS_NOTIF_DATA = 'reports/set-single-event-notif-data';
export const RESET_CALENDAR_EVENTS_NOTIF = 'reports/reset-single-event-notif';
export const SET_SINGLE_EVENT_DATA = 'reports/set-single-event-data';
export const SET_TIMEZONE_DATA = 'reports/set-timezone-data';
